module.exports = __webpack_public_path__ + "img/poissonhachee.e86be4d7.png";